<template>
  <div class="services">
    <div class="site-content">
      <div
        class="page-header"
        :style="{backgroundImage:`url(${require('../assets/images/subheader-1.jpg')})`}"
        style="background:no-repeat center center;"
      >
        <div class="container">
          <div class="breadc-box no-line">
            <div class="row">
              <div class="col-md-12">
                <h2 class="page-title">定制服务</h2>
                <ul id="breadcrumbs" class="breadcrumbs none-style">
                  <li>
                    <router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link>
                  </li>
                  <li class="active">技术服务</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row flex-row">
            <div class="col-sm-7 col-xs-12">
              <h4 class="text-primary">服务说明</h4>
              <h2>定制服务</h2>
              <br />
							<p><b>为了提高服务效率、加强双方沟通，各地代理商（或客户）需满足以下的要求：</b></p>
              <p>
                <i class="fa fa-play"></i> &nbsp;需要指派一名技术负责人，负责双方的沟通协调
              </p>
              <p>
                <i class="fa fa-play"></i> &nbsp;通过邮件或传真提交的技术问题和投诉，需要注明公司、联系人、电话、日期等
              </p>
              <p>
                <i class="fa fa-play"></i> &nbsp;对于功能修改或技术问题，需要写明产品版本及模块，将问题和需求分开，以便我司快速定位并解决问题
              </p>
              <p>
                <i class="fa fa-play"></i> &nbsp;对我司提出的解决方案，请尽快安排人员测试并反馈
              </p>
              <p>
                <i class="fa fa-play"></i> &nbsp;随时监督我司的技术服务，如有任何建议和意见，请及时联系我们
              </p>
            </div>
						<div class="col-md-5 col-sm-12 align-self-center">
              <img src="../assets/images/service-1.png" alt />
            </div>
          </div>
          <div class="industris-space-90 sm-hidden"></div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "services_custom",
  components: {},
};
</script>

<style>
.fa-play {
  color: #1a94e6;
}
</style>



// WEBPACK FOOTER //
// src/pages/services_custom.vue